import { render, staticRenderFns } from "./tabPanel.vue?vue&type=template&id=a218fc8e&"
import script from "./tabPanel.vue?vue&type=script&lang=js&"
export * from "./tabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports